import React from 'react'
import Path2 from '../Paths/path2'
import {Grid} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'

const useStyles=makeStyles((themes)=>({

    aboutme:{
        backgroundColor:"white",
        textAlign:"center",
        paddingLeft:"7.5%",
        paddingRight:"7.5%"
    },
    path:{
        backgroundColor:"white",
    
    }
}))


export default function Intro2(){

    const classes =useStyles();

    return(

        <div>
            <Grid container>
                <Grid item xs={12} md={12} className={classes.aboutme}>
                    <Path2 className={classes.path}></Path2>
                </Grid>
            </Grid>

        </div>
    )
}